import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "@/shapeStorage/shapes/shape";

export class ShapeStartEventNonInterrupting extends Shape {
    defaultBorderDashType = "dashed";
    defaultBorderWidth = 3;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            height / 2,
            width / 2,
            Math.PI / 2,
            0,
            2 * Math.PI,
        );
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m12 23c-2.08377 0-4.03221-.5794-5.69301-1.5859m-5.30699-9.4141c0-2.01453.54154-3.90258 1.48699-5.52651m9.51301-5.47349c1.9945 0 3.8651.53084 5.4781 1.45896m2.0476 1.51829c1.4527 1.36321 2.535 3.11644 3.0797 5.09256m-1.2893 8.78189c1.1254-1.7879 1.7493-3.9532 1.6783-6.2045m-3.1435 8.0576c-1.3912 1.4174-3.1632 2.4597-5.1504 2.9613m-10.30167-2.7148c-1.47056-1.4062-2.55168-3.2163-3.06525-5.2522m2.70458-10.2892c1.3927-1.46047 3.18315-2.53829 5.19755-3.05966"
                 stroke="${stroke}" fill="${fill}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
